/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorRequestTable.vue?vue&type=template&id=43aae168"
import script from "./DoctorRequestTable.vue?vue&type=script&lang=js"
export * from "./DoctorRequestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43aae168')) {
      api.createRecord('43aae168', component.options)
    } else {
      api.reload('43aae168', component.options)
    }
    module.hot.accept("./DoctorRequestTable.vue?vue&type=template&id=43aae168", function () {
      api.rerender('43aae168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DoctorRequestTable.vue"
export default component.exports